"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');



var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _noticeBar = require('web/services/context/noticeBar');

/**
 * Whether broadcasts are locked because BloomText hasn't verified the org,
 * and whether its subscription already asked for verification this billing
 * period. The server refuses unverified broadcasts either way; this only
 * decides what the screen shows. A failed lookup shows the normal screen.
 */
const useBroadcastVerification = (orgKey, enabled) => {
  const [status, setStatus] = _react.useState(null)
  const [hasFailed, setHasFailed] = _react.useState.call(void 0, false)
  const [isRequesting, setIsRequesting] = _react.useState.call(void 0, false)
  const { showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )

  _react.useEffect.call(void 0, () => {
    setStatus(null)
    setHasFailed(false)
    if (!enabled || !orgKey) return undefined
    let isActive = true
    _actions2.default.getVerificationStatus({ OrgKey: orgKey })
      .then(next => { if (isActive) setStatus(next) })
      .catch(() => { if (isActive) setHasFailed(true) })
    return () => { isActive = false }
  }, [orgKey, enabled])

  const onRequest = _react.useCallback.call(void 0, async () => {
    if (!orgKey) return
    setIsRequesting(true)
    try {
      setStatus(await _actions2.default.requestVerification({ OrgKey: orgKey }))
    } catch (e) {
      showWarningBar('Something went wrong. Please try again.')
    } finally {
      setIsRequesting(false)
    }
  }, [orgKey, showWarningBar])

  return {
    isLoading: enabled && !!orgKey && !status && !hasFailed,
    isLocked: !!status && status.Enforced && !status.Verified,
    isRequested: !!_optionalChain([status, 'optionalAccess', _ => _.Requested]),
    isRequesting,
    onRequest,
  }
}

exports. default = useBroadcastVerification
